import { gql } from '@apollo/client';

export default gql`
  query combinedTransactions {
    combinedTransactions {
      orderTransactions {
        id
        state
        total
        message
        status
        amountApproved
        createdAt
        transactionId
        order {
          id
          hexCode
        }
        accountCreditCard {
          id
          brand
          maskedNumber
        }
      }
      subscriptionTransactions {
        id
        state
        total
        message
        status
        amountApproved
        createdAt
        transactionId
        subscription {
          id
          name
          hexCode
          patient {
            id
            firstName
            lastName
          }
        }
        accountCreditCard {
          id
          brand
          maskedNumber
        }
      }
    }
  }
`;
